import { useTranslation } from "react-i18next";

import { Section, SectionHeader, SectionTitle } from "@/blocks/Section/Section";
import { useCall } from "@/hooks/useCall/useCall";
import { TalkRatioList } from "./TalkRatioList";

export function SectionTalkRatio() {
  const { t } = useTranslation();
  const { call } = useCall();

  if (!call) {
    return null;
  }

  return (
    <Section data-test="talk-ratio-section">
      <SectionHeader>
        <SectionTitle>{t("call_context.talk_ratio")}</SectionTitle>
      </SectionHeader>
      <TalkRatioList speakers={call.speakers} talkRatio={call.talkRatio} />
    </Section>
  );
}
